import DefaultTheme from '@web-ui-kit/themes.default-theme'
import ThemeProvider from '@web-ui-kit/themes.theme-provider'
import Fonts from '@web-ui-kit/fonts'

const RebrandingProvider = ({ children }) => {
  return (
    <ThemeProvider theme={DefaultTheme}>
      <Fonts />
      {children}
    </ThemeProvider>
  )
}

export default RebrandingProvider
